// \r 转 <br/>
const textToHtml = () => {
    return text => {
        return text.replace(/\r\n/ig, '<br/>');
    }
}

export default {
    textToHtml
}